export const RouteEnum = {
    Home: 'home',
    Calendar: 'calendar',
    Repository: 'repository',
    Tasks: 'Tasks',
    Messages: 'Messages',
    AIAssist: 'AI Assist',
    More: 'more',
};
